import {AxiosRequestConfig} from 'axios'
const auth_token_key = process.env.REACT_APP_AUTH_TOKEN_KEY!

// Flag to ensure interceptors are only added once
let isAxiosSetup = false

export function setupAxios(axios: any) {
  // Prevent adding interceptors multiple times
  if (isAxiosSetup) {
    return
  }
  
  const token = localStorage.getItem(auth_token_key)
  axios.defaults.headers.Accept = 'application/json'
  axios.interceptors.request.use(
    (request: AxiosRequestConfig) => {
      // In development only: log request method and url to help debugging
      if (process.env.NODE_ENV !== 'production') {
        console.info('axios request:', request.method?.toUpperCase(), request.url)
      }
      
      // Get fresh token on each request
      const freshToken = localStorage.getItem(auth_token_key)
      if (freshToken && request.headers) {
        request.headers.Authorization = `Bearer ${freshToken}`
      }
      
      return request
    },
    (err: any) => {
      console.error('axios request error:', err)
      return Promise.reject(err)
    }
  )
  // Log responses and errors globally to surface server issues
  axios.interceptors.response.use(
    (response: any) => {
      return response
    },
    (error: any) => {
      // Handle 401 Unauthorized - redirect to login
      if (error.response?.status === 401) {
        console.warn('401 Unauthorized - redirecting to login')
        // Clear token and redirect to login
        localStorage.removeItem(auth_token_key)
        window.location.href = '/auth/login'
        return Promise.reject(error)
      }
      
      // Handle 500 errors gracefully for chatbot endpoints
      if (error.response?.status === 500 && error.config?.url?.includes('/chatbot/')) {
        console.warn('Chatbot API error - returning empty response')
        // Return a mock successful response for chatbot endpoints
        return Promise.resolve({
          data: {
            success: true,
            data: {
              responses: []
            }
          }
        })
      }
      
      // Handle other 500 errors gracefully
      if (error.response?.status === 500) {
        console.warn('Server error - API temporarily unavailable')
        // For non-chatbot 500 errors, still reject but with better error message
        return Promise.reject(new Error('Server temporarily unavailable'))
      }
      
      console.error('axios response error:', error.config?.url, error.response?.status, error.response?.data || error.message)
      return Promise.reject(error)
    }
  )
  
  // Mark as setup to prevent duplicate interceptors
  isAxiosSetup = true
}
